import { render, staticRenderFns } from "./i-uploader.vue?vue&type=template&id=e6328540&scoped=true&"
import script from "./i-uploader.vue?vue&type=script&lang=js&"
export * from "./i-uploader.vue?vue&type=script&lang=js&"
import style0 from "./i-uploader.vue?vue&type=style&index=0&id=e6328540&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6328540",
  null
  
)

export default component.exports